import useRegionList from 'components/StoreSelector/hooks/useRegionList';
import { useMemo } from 'react';

export const useOnlyMercadoPlatform = () => {
  const { platformList } = useRegionList();

  return useMemo(() => platformList.length === 1 && platformList[0] === 'MERCADO', [platformList]);
};
